/**
 * Lire ce que le service de temps écrit, sans lui faire confiance.
 *
 * Sa charge publiée et ses réponses viennent d'un service qu'on ne déploie pas
 * au même rythme que le studio : une version plus récente peut ajouter des
 * champs, une plus ancienne en omettre. On ne valide que ce dont on se sert,
 * et un champ illisible vaut `null` — c'est à l'appelant de dire ce que vaut
 * son absence, parce qu'elle ne vaut pas la même chose partout : un lead
 * absent est un lead vacant, un délai absent ne doit retarder personne.
 */

/** Un objet JSON, et pas un tableau ni `null`. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/** Un nombre fini, ou `null`. */
export function finiteNumber(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

/**
 * Une durée en millisecondes, ou `null`.
 *
 * Un négatif est illisible, pas une durée : un retard négatif ferait courir la
 * tête de lecture *devant* la séance, et les notes reçues seraient déjà
 * passées à l'arrivée.
 */
export function durationOrNull(value: unknown): number | null {
  const number = finiteNumber(value);

  if (number === null || number < 0) {
    return null;
  }

  return number;
}

/** Un compte de personnes, entier et positif, ou `null`. */
export function countOrNull(value: unknown): number | null {
  const number = finiteNumber(value);

  if (number === null || number < 0) {
    return null;
  }

  return Math.floor(number);
}
